import {HttpClient, HttpContext} from '@angular/common/http'
import {inject, Service} from '@angular/core'
import {MatSnackBar} from '@angular/material/snack-bar'
import {X_API_KEY} from '@sparbanken-syd/sparbanken-syd-bankid'
import {EMPTY, Observable} from 'rxjs'
import {catchError, map} from 'rxjs/operators'
import {environment} from '../../environments/environment'
import {SECRET} from '../../environments/secret'

export interface Interest {
  [key: number]: number

  createdByName: string
  version: number
  approvedByName: string
  itemId: string
  interestStartDate: number
  createdBySub: string
  approvedBySub: string
  eSpar: number
  horse: number
  timeStamp: number
  interfaceDate: number
  typeOfInterest: string
}


@Service()
export class InterestService {
  private readonly snackBar = inject(MatSnackBar)
  private readonly httpClient = inject(HttpClient)

  /**
   * Get the latest valid interest from database
   */
  public getLatestInterest(): Observable<Interest> {
    const context = new HttpContext().set(X_API_KEY, SECRET)
    const url = `${environment.rtUrl}/interests/latest/fkInterests`
    return this.httpClient.get<Interest>(url, {context})
      .pipe(
        catchError(() => {
          this.snackBar.open('Ett fel har inträffat. Räntan som anges är inte korrekt. Kontrollera din internetanslutning', 'OKEJ', {
            horizontalPosition: 'center',
            verticalPosition: 'top'
          })
          return EMPTY
        }),
        map(interest => interest)
      )
  }
}
